module.exports = __webpack_public_path__ + "fonts/SofiaProBold-Italic.ce364690.woff";